import React from "react";
import { useTranslation } from "react-i18next";
import SiteWrapper from "components/Layouts/SiteWrapper";
import { useNavigate } from "react-router-dom";
import SiteDetailsContent from "./SiteDetailsContent";
import { useParams } from "react-router-dom";
import { getLocalStorageData } from "helpers/utils";
import { getSiteNavigationFromStorage } from "helpers/siteNavigation";

const SiteDetail = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { id, clientId } = useParams();

	const navigation = getSiteNavigationFromStorage(getLocalStorageData);

    return (
        <SiteWrapper
            navigation={navigation}
            onNavClick={(urlToGo) =>
                navigate(`/app/clients/${clientId}/sites/${id}${urlToGo}`)
            }
            current={t("title.details")}
        >
            <SiteDetailsContent />
        </SiteWrapper>
    );
};

export default SiteDetail;
